/**
 * editing utils
 * 
 * @author    Jens Gruschel
 * @copyright © 2020 contexagon GmbH
 */


import _ from 'lodash';


/**
 * check if a value is undefined, empty, "", [] or {}
 * @param value         given value
 * @returns {boolean}   true if value is empty, otherwise false
 * @author Jens Gruschel
 */
export function isEmpty(value) {

    if (value == null) return true;
    else if (Array.isArray(value) && value.length === 0) return true;
    else if (value instanceof Object) {
        for (const prop in value) return false;
        return true;
    }
    else return false;
}


/**
 * return a copy of the given object with the given nested property
 * replaced by a new value, cleaning up empty values or sub objects
 * (works similar as Lodash _.set and supportes objects and arrays as well)
 * @param object        given object
 * @param fieldPath     path to the field as array
 * @param value         value to set
 * @returns {Object}    new state
 * @author Jens Gruschel
 */
export function replaceNestedObjectProperty(object, fieldPath, value) {

    if (!fieldPath || fieldPath.length === 0) {
        return value;
    }

    const firstKey = fieldPath[0];

    // clone array or object (or create new one)
    let result = _.isNumber(firstKey) ? (object ? [...object] : []) : (object ? {...object} : {});

    const subObject = (fieldPath.length > 1) ? replaceNestedObjectProperty(result[firstKey], fieldPath.slice(1), value) : value;

    if (isEmpty(subObject)) {
        // instead of leaving fields with empty sub objects, remove them, which makes comparison of objects easier
        delete result[firstKey];
    }
    else {
        result[firstKey] = subObject;
    }
    return result;
}